import React from "react";
import { Col } from "react-bootstrap";

import { EMPTY_STRING, salesSummaryConstants } from "../../../constants";

const SalesSummaryDatarow = ({
  dataRowType = 3,
  title = EMPTY_STRING,
  value = EMPTY_STRING,
  className = "",
  fontClassName = "sales-summary-heading",
}) => {
  return dataRowType === salesSummaryConstants.ROW_TYPE_1 ? (
    <Col md={12} className={className}>
      <div className="d-flex justify-content-between align-items-center p-3 footer-border-dark ">
        <span className={fontClassName}>{title}</span>
        <span className={fontClassName}>{value}</span>
      </div>
    </Col>
  ) : dataRowType === salesSummaryConstants.ROW_TYPE_2 ? (
    <Col md={12} className={className}>
      <div className="d-flex justify-content-between align-items-center p-3 header-border-dark-border ">
        <span className={fontClassName}>{title}</span>
        <span className={fontClassName}>{value}</span>
      </div>
    </Col>
  ) : dataRowType === salesSummaryConstants.ROW_TYPE_3 ? (
    <Col md={12} className={className}>
      <div className="d-flex justify-content-between align-items-center p-3 detail-div-border">
        <span className={fontClassName}>{title}</span>
        <span className={fontClassName}>{value}</span>
      </div>
    </Col>
  ) : (
    ""
  );
};

export default SalesSummaryDatarow;
